export default __webpack_public_path__ + "static/media/world.3135889a.png";